import getCampanhaDesconto from "./campanhaDesconto";

export const planoElegivelParaDesconto = (planoTaxaAdmTotal, campanha) => {
  if (!campanha || planoTaxaAdmTotal === undefined || planoTaxaAdmTotal === null) {
    return false;
  }

  const taxa = parseFloat(planoTaxaAdmTotal);

  if (isNaN(taxa)) return false;

  if (campanha.taxa_igual !== null && campanha.taxa_igual !== undefined) {
    return taxa === parseFloat(campanha.taxa_igual);
  }

  if (
    campanha.taxa_igual_menor !== null &&
    campanha.taxa_igual_menor !== undefined
  ) {
    return taxa <= parseFloat(campanha.taxa_igual_menor);
  }

  return false;
};

export const getValorPrimeiraParcelaComDesconto = (
  valorParcelaPrimeiroPagto,
  campanha,
) => {
  const percentual = parseFloat(campanha.desconto) / 100;

  if (isNaN(percentual)) return valorParcelaPrimeiroPagto;

  return valorParcelaPrimeiroPagto * (1 - percentual);
};

export const getDescontoParaPlano = (plano) => {
  const campanha = getCampanhaDesconto();

  if (!planoElegivelParaDesconto(plano?.planoTaxaAdmTotal, campanha)) {
    return null;
  }

  return {
    ...campanha,
    valorPrimeiraParcelaComDesconto: getValorPrimeiraParcelaComDesconto(
      plano.valorParcelaPrimeiroPagto,
      campanha,
    ),
  };
};

export default getDescontoParaPlano;
